module.exports = __webpack_public_path__ + "img/icon-marketplace.8dbcf234.svg";